import { createSlice } from "@reduxjs/toolkit";

const GiftsSlice = createSlice({
  name: "gifts",
  initialState: {
    loading: false,
    data: [],
    total: 0,
    message: "",
    error: null,
  },
  reducers: {
    fetchGiftsRequest: (state) => {
      state.loading = true;
    },
    fetchGiftsSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.gifts;
      state.total = action.payload.total;
      state.message = action.payload.message;
      state.error = null;
    },
    fetchGiftsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchGiftsRequest,
  fetchGiftsSuccess,
  fetchGiftsFailure,
} = GiftsSlice.actions;

export default GiftsSlice.reducer;
